export default {
  labels: {
    free_items: 'Free items',
    bogo: 'Buy One, Get One Free',
    order_again: 'Order again',
  },
};
